import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	SimpleChanges,
	ViewChild,
	ElementRef,
} from '@angular/core';
import { environment } from '@environment/environment';
import { ConfirmationDialogComponent } from '../../common/confirmation-dialog/confirmation-dialog.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { LoadingSpinnerDialogComponent } from '@shared/loading-spinner-dialog/loading-spinner-dialog.component';
import { UtilService } from '@service/util/util.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { PRICING_PREVIEW } from '@domain/constants/pricing-preview';
import { UrlService } from '@service/url/url.service';
import { Cargochief } from '@service/cargochief/cargochief.service';
import { SegmentEventsConstants } from '@domain/constants/segment-events-constants';
import {
	GET_UNIX_TIMESTAMP,
	IS_NOT_EMPTY,
	IS_NOT_NULL_OR_UNDEFINED,
	POPULATE_FOR_THIS_ACCOUNT_ATTRIBUTE,
	RestService,
	TransactionDTO,
	IS_NULL_OR_UNDEFINED,
	DIFFERENCE_IN_DAYS,
	DATE_YMD,
	TO_DOLLARS,
} from 'cargo-chief-commons';
import { CurrencyPipe } from '@angular/common';
import { AddPriceReviewDialogComponent } from '../add-price-review-dialog/add-price-review-modal';
import { catchError, finalize, timeout } from 'rxjs/operators';
import { of } from 'rxjs';
import { RecentTransactionsDialogComponent } from './../recent-transactions-dialog/recent-transactions-dialog';
import { AccountSettingsService } from '@service/accountSettings/account-settings.service';
import { PricingFeedbackService } from '@service/pricingFeedback/pricing-feedback.service';
import { HttpErrorResponse } from '@angular/common/http';
import { SORT_BY_DATE } from '@domain/constants/functions';
import { RECENT_TRANSACTION_SORT } from '@domain/constants/app-variables';
import { PRICING_ERROR } from '@domain/constants/error';
import { ProductsService } from '@service/products/products.service';
import { PricingHelperService } from '@service/pricing-helper/pricing-helper.service';
import { RecentTransactionsCount } from '@domain/interface/recent-transactions-count';

@Component({
	selector: 'app-pricing',
	templateUrl: './pricing.component.html',
	styleUrls: ['./pricing.component.scss'],
	providers: [CurrencyPipe],
})
export class PricingComponent implements OnInit {
	@Input() searchTruckForm: any = null;
	@Input() truckLaneSearchId: string = null;
	@Input() truckSearchId: string = null;
	@Input() inOpportunitiesPage: boolean = false;
	@Input() v1PricingLayout: boolean = true;
	@Input() greenScreensEnabled: boolean = false;
	@Output() lanePricingCompleted = new EventEmitter<any>();
	@Output() pricingFeedbackSubmitted = new EventEmitter<any>();
	searchTruckFormCopy: any = null;
	SEGMENT_EVENTS = SegmentEventsConstants;

	recentTransactions: Array<TransactionDTO> = null;
	lanePricing: any = null;

	environment = environment;

	showCurrentRatesCard: boolean = false;
	showRecentTransactionsCard: boolean = true;
	rateFeedbackProvided = false;
	loadsUsed: string = '';
	accountId: number = null;
	priceNotFound = false;
	searchRadius = null;

	totalTransactions!: number;
	numberOfPastDaysTransaction!: number;

	isLanePricingRequestInProgress: boolean = false;
	isRecentTransactionsRequestInProgress: boolean = false;
	isRecentTransactionsCountRequestInProgress: boolean = false;
	isGreenScreenRequestInProgress: boolean = false;
	greenScreenRate: { targetBuyRate: number; startBuyRate: number } = null;
	agedTransactionCount: boolean = false;

	IS_NOT_EMPTY = IS_NOT_EMPTY;
	IS_NOT_NULL_OR_UNDEFINED = IS_NOT_NULL_OR_UNDEFINED;
	IS_NULL_OR_UNDEFINED = IS_NULL_OR_UNDEFINED;
	TO_DOLLARS = TO_DOLLARS;
	CONFIDENCE_METER_CONTAINER = '85px';

	@ViewChild('perMileEndContaier') perMileEndContaier: ElementRef;
	@ViewChild('perMileEndTextContainer') perMileEndTextContainer: ElementRef;
	@ViewChild('recentTransactionsLink') recentTransactionsLink: ElementRef;
	@ViewChild('allInPriceContainer', { read: ElementRef }) allInPriceContainer: ElementRef;
	@ViewChild('allInPriceEnd') allInPriceEnd: ElementRef;
	recentTransactionsCount!: RecentTransactionsCount;

	constructor(
		public dialog: MatDialog,
		public utilService: UtilService,
		private urlService: UrlService,
		public cargochief: Cargochief,
		private restService: RestService,
		public accountSettings: AccountSettingsService,
		private pricingFeedbackService: PricingFeedbackService,
		public productsService: ProductsService,
		public pricingHelperService: PricingHelperService
	) {
		this.accountId = this.cargochief.ACCOUNT_ID;
	}

	ngOnInit() {}

	ngOnChanges(changes: SimpleChanges) {
		if (
			IS_NOT_NULL_OR_UNDEFINED(changes.searchTruckForm) &&
			IS_NOT_NULL_OR_UNDEFINED(this.searchTruckForm)
		) {
			if (this.pricingHelperService.isCitySelected(this.searchTruckForm)) {
				this.searchTruckFormCopy = Object.assign({}, this.searchTruckForm);
				this.rateFeedbackProvided = false;
				if (
					this.productsService.PRICING &&
					this.pricingHelperService.hasSearchChanged(
						changes.searchTruckForm.previousValue,
						changes.searchTruckForm.currentValue
					)
				) {
					this.searchRadius = null;
					this.loadsUsed = '';
					this.getLanePricing();
					this.getRecentTransactionsCount();
					if (this.greenScreensEnabled) {
						this.getGreenScreensLanePricing();
					}
				}
			} else {
				this.showRecentTransactionsCard = false;
				this.showCurrentRatesCard = false;
				this.priceNotFound = true;
			}
		} else if (
			this.pricingHelperService.greenScreensEnabledValueChanged(changes) &&
			this.greenScreensEnabled
		) {
			this.getGreenScreensLanePricing();
		}
	}

	openPricingPreviewDialog(eventName: string) {
		this.pricingHelperService.fireSegmentEvent(eventName);
		const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
			width: '900px',
			data: {
				title: 'Real Time Pricing with LaneMaster',
				body: PRICING_PREVIEW,
				cancelButtonText: '',
				ConfirmButtonTest: 'Request Info',
				showCloseButton: false,
				buttonActionLayout: 'center center',
			},
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (IS_NOT_NULL_OR_UNDEFINED(result) && result) {
				this.signupConfirmed();
				this.pricingHelperService.fireSegmentEvent(
					SegmentEventsConstants.user_registered_for_pricing
				);
			}
		});
	}

	openPriceReviewDialog() {
		this.dialog.open(AddPriceReviewDialogComponent, {
			width: '500px',
		});
	}

	signupConfirmed() {
		const loadingDialog = this.dialog.open(LoadingSpinnerDialogComponent, {
			width: '300px',
		});
		const url = this.urlService.registerForPricingPreview(this.cargochief.USER_ID);
		this.restService.POST(url, {}).subscribe(
			(result) => {
				this.pricingHelperService.emailSentSuccessfully();
				loadingDialog.close();
			},
			(error) => {
				if (error.status == 200) {
					this.pricingHelperService.emailSentSuccessfully();
				} else {
					this.utilService.showSnackbar(
						'Unable to register you now. Please try again.',
						SNACKBAR.ERROR,
						SNACKBAR.ACTION
					);
				}
				loadingDialog.close();
			}
		);
	}

	getRecentTransactions({ isSecondCall } = { isSecondCall: false }) {
		this.isRecentTransactionsRequestInProgress = true;
		this.showRecentTransactionsCard = true;
		this.searchTruckFormCopy = {
			...this.searchTruckFormCopy,
			originDeadhead: this.searchRadius || 100,
			destinationDeadhead: this.searchRadius || 100,
		};
		if (isSecondCall) {
			this.searchTruckFormCopy = {
				...this.searchTruckFormCopy,
				age: environment.RECENT_TRANSACTION_AGE,
			};
		} else {
			this.recentTransactions = null;
		}
		const url = this.urlService.getRecentTransactions(0, 5);
		this.restService
			.POST(url, this.searchTruckFormCopy)
			.pipe(
				finalize(() => {
					this.isRecentTransactionsRequestInProgress = false;
				})
			)
			.subscribe(
				(result) => {
					this.recentTransactions = SORT_BY_DATE(
						POPULATE_FOR_THIS_ACCOUNT_ATTRIBUTE(result.data, this.accountId),
						RECENT_TRANSACTION_SORT.PICKUP_DATE
					);
					if (result.data.length) {
						this.totalTransactions = result.data.totalElements || result.data.length;
						this.numberOfPastDaysTransaction = Math.abs(
							DIFFERENCE_IN_DAYS(
								DATE_YMD(new Date()),
								DATE_YMD(result.data[result.data.length - 1].pickupDate)
							)
						);
					} else {
						this.totalTransactions = null;
						this.numberOfPastDaysTransaction = null;
					}
					if (this.recentTransactions.length == 0) {
						if (isSecondCall) {
							this.showRecentTransactionsCard = false;
						} else {
							this.getRecentTransactions({ isSecondCall: true });
						}
					}
					this.pricingFeedbackService.firePricingSegmentEvent(
						SegmentEventsConstants.user_viewed_recent_transactions,
						'response',
						this.recentTransactions,
						null,
						this.truckSearchId,
						this.truckLaneSearchId,
						this.searchTruckForm,
						null,
						this.recentTransactions.length
					);
				},
				(error) => {
					let errorMessage = PRICING_ERROR.RECENT_TRANSACTION.DEFAULT;
					if (error.status === 422) {
						errorMessage = error.error;
					}
					this.utilService.showSnackbar(errorMessage, SNACKBAR.WARNING, SNACKBAR.ACTION);
					this.showRecentTransactionsCard = false;
					this.pricingFeedbackService.firePricingSegmentEvent(
						SegmentEventsConstants.recent_transactions_failed_for_search,
						'response',
						this.recentTransactions,
						null,
						this.truckSearchId,
						this.truckLaneSearchId,
						this.searchTruckForm
					);
				}
			);
	}

	getLanePricing() {
		this.isLanePricingRequestInProgress = true;
		this.showCurrentRatesCard = true;
		this.lanePricing = null;
		this.lanePricingCompleted.emit(this.lanePricing);
		this.priceNotFound = false;
		const url = this.urlService.getLanePricing();
		this.restService
			.POST(url, this.searchTruckFormCopy)
			.pipe(
				timeout(120000),
				finalize(() => {
					this.isLanePricingRequestInProgress = false;
					if (this.productsService.RECENT_TRANSACTIONS && this.v1PricingLayout) {
						this.getRecentTransactions();
					}
				}),
				catchError((error: HttpErrorResponse) => {
					let errorMessage = PRICING_ERROR.LANE_PRICING.DEFAULT;
					if (error.status === 404) {
						errorMessage = PRICING_ERROR.LANE_PRICING.ERR_404;
						this.priceNotFound = true;
					} else if (error.status === 422) {
						errorMessage = error.error;
						this.showCurrentRatesCard = false;
					} else {
						this.showCurrentRatesCard = false;
					}
					this.utilService.showSnackbar(errorMessage, SNACKBAR.WARNING, SNACKBAR.ACTION);
					this.pricingFeedbackService.firePricingSegmentEvent(
						SegmentEventsConstants.current_price_failed_for_search,
						'lanePricing',
						this.lanePricing,
						null,
						this.truckSearchId,
						this.truckLaneSearchId,
						this.searchTruckForm
					);
					return of(null);
				})
			)
			.subscribe(
				(result) => {
					if (IS_NOT_NULL_OR_UNDEFINED(result) && IS_NOT_NULL_OR_UNDEFINED(result.data)) {
						this.lanePricing = result.data;
						this.searchRadius = result.data.searchRadius || 100;
						this.lanePricingCompleted.emit(this.lanePricing);
						if (
							IS_NULL_OR_UNDEFINED(this.lanePricing.loadsUsed) ||
							(IS_NOT_NULL_OR_UNDEFINED(this.lanePricing.loadsUsed) &&
								this.lanePricing.loadsUsed == 0) ||
							(IS_NOT_NULL_OR_UNDEFINED(this.lanePricing.loadsUsed) &&
								this.lanePricing.loadsUsed > 5000)
						) {
							this.loadsUsed = '> 5000';
						} else {
							this.loadsUsed = String(this.lanePricing.loadsUsed);
						}
					}
					this.pricingFeedbackService.firePricingSegmentEvent(
						SegmentEventsConstants.user_viewed_current_price,
						'lanePricing',
						this.lanePricing,
						null,
						this.truckSearchId,
						this.truckLaneSearchId,
						this.searchTruckForm
					);
				},
				(error) => {
					this.utilService.showSnackbar(
						'Unable to load Current Rates.',
						SNACKBAR.WARNING,
						SNACKBAR.ACTION
					);
					this.showCurrentRatesCard = false;
					this.pricingFeedbackService.firePricingSegmentEvent(
						SegmentEventsConstants.current_price_failed_for_search,
						'lanePricing',
						this.lanePricing,
						null,
						this.truckSearchId,
						this.truckLaneSearchId,
						this.searchTruckForm
					);
				}
			);
	}

	getGreenScreensLanePricing() {
		this.greenScreenRate = null;
		this.isGreenScreenRequestInProgress = true;
		const url = this.urlService.getGreenScreensLanePricing();
		const searchTruckForm = this.pricingHelperService.retainSingleEquipment(
			this.searchTruckFormCopy
		);
		this.restService
			.POST(url, searchTruckForm)
			.pipe(
				finalize(() => {
					this.isGreenScreenRequestInProgress = false;
				})
			)
			.subscribe(
				(result) => {
					this.greenScreenRate = result['data'];
				},
				(error) => {
					this.utilService.showSnackbar(
						'Unable to get rates from GreenScreens',
						SNACKBAR.WARNING,
						SNACKBAR.ACTION
					);
				}
			);
	}

	convertDateToTimestamp() {
		this.searchTruckFormCopy.pickupDateEnd = GET_UNIX_TIMESTAMP(
			this.searchTruckFormCopy.pickupDateEnd
		);
		this.searchTruckFormCopy.pickupDateStart = GET_UNIX_TIMESTAMP(
			this.searchTruckFormCopy.pickupDateStart
		);
	}

	openRecentTransactionsDialog() {
		this.dialog.open(RecentTransactionsDialogComponent, {
			width: '900px',
			data: {
				transactions: this.recentTransactions,
				searchTruckForm: this.searchTruckFormCopy,
				accountId: this.accountId,
				recentTransactionsCount: this.recentTransactionsCount.totalTransactions,
				ageTransactionCount: this.agedTransactionCount,
			},
		});
	}

	//TODO: going ahead we should move this to a dumb component
	async submitRateFeedback(feedbackType: 'spotOn' | 'notAccurate', rateType: string = null) {
		this.rateFeedbackProvided = true;
		switch (feedbackType) {
			case 'spotOn':
				const spotOnFeedbackData = {
					rateType: 'spotOn',
					hasRate: true,
					currentRate: Math.round(this.lanePricing.allInCost),
				};
				this.pricingFeedbackService.firePricingSegmentEvent(
					SegmentEventsConstants.user_submitted_rate_feedback,
					'lanePricing',
					this.lanePricing,
					spotOnFeedbackData,
					this.truckSearchId,
					this.truckLaneSearchId,
					this.searchTruckForm,
					this.pricingFeedbackService.FEEDBACK_TYPE.SPOT_ON
				);
				this.pricingFeedbackService.submitLanePriceReview(
					this.lanePricing['lanePriceSearchId'],
					spotOnFeedbackData
				);
				this.pricingFeedbackService.showFeedbackSuccessSnackbar();
				break;
			case 'notAccurate':
				const dialogResponse = await this.pricingFeedbackService.openPricingFeedbackDialog({
					openedManually: true,
					rateType,
				});
				if (IS_NULL_OR_UNDEFINED(dialogResponse)) {
					this.rateFeedbackProvided = false;
					return;
				}
				let feedbackData = dialogResponse?.feedbackData;
				if (IS_NOT_NULL_OR_UNDEFINED(feedbackData)) {
					this.pricingFeedbackService.firePricingSegmentEvent(
						SegmentEventsConstants.user_submitted_rate_feedback,
						'lanePricing',
						this.lanePricing,
						feedbackData,
						this.truckSearchId,
						this.truckLaneSearchId,
						this.searchTruckForm,
						this.pricingFeedbackService.FEEDBACK_TYPE.INACCURATE
					);
					this.pricingFeedbackService.submitLanePriceReview(
						this.lanePricing['lanePriceSearchId'],
						feedbackData
					);
					this.pricingFeedbackService.showFeedbackSuccessSnackbar();
				}
				break;
		}
		this.pricingFeedbackSubmitted.emit();
	}

	renderRecentTransactions(): boolean {
		return (
			this.showRecentTransactionsCard &&
			IS_NOT_NULL_OR_UNDEFINED(this.recentTransactions) &&
			this.recentTransactions.length > 0
		);
	}

	getRecentTransactionsCount({ isSecondCall } = { isSecondCall: false }) {
		this.recentTransactionsCount = null;
		this.isRecentTransactionsCountRequestInProgress = true;
		this.searchTruckFormCopy = {
			...this.searchTruckFormCopy,
			originDeadhead: this.searchRadius || 100,
			destinationDeadhead: this.searchRadius || 100,
		};
		if (isSecondCall) {
			this.agedTransactionCount = true;
			this.searchTruckFormCopy = {
				...this.searchTruckFormCopy,
				age: environment.RECENT_TRANSACTION_AGE,
			};
		} else {
			this.recentTransactionsCount = null;
		}
		const url = this.urlService.getRecentTransactionsCount();
		this.restService
			.POST(url, this.searchTruckFormCopy)
			.pipe(
				finalize(() => {
					this.isRecentTransactionsCountRequestInProgress = false;
				})
			)
			.subscribe(
				(result) => {
					if (result.data.totalTransactions) {
						this.recentTransactionsCount = result.data;
					} else if (!isSecondCall) {
						this.getRecentTransactionsCount({ isSecondCall: true });
					}
				},
				(error) => {
					let errorMessage = PRICING_ERROR.RECENT_TRANSACTION.DEFAULT;
					if (error.status === 422) {
						errorMessage = error.error;
					}
					this.utilService.showSnackbar(errorMessage, SNACKBAR.WARNING, SNACKBAR.ACTION);
					this.showRecentTransactionsCard = false;
				}
			);
	}
}
